<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records interaction-checker">
            <div class="row">
                <div class="col-md-12 col-12 mb-4 Order Confirmed">
                    <div class="bg-white border-radius-5 p-5 Order">
                        <div class="card border-0">
                            <div class="card-body p-0">
                                <div class="row no-gutters justify-content-center">
                                    <div class="col-md-9">
                                        <div class="text-center border-radius-8 p-4 mb-5 interaction">
                                            <h2 class="mb-4">Drug Interaction Checker</h2>

                                            <div class="row justify-content-center">
                                                <div class="col-md-10">
                                                    <div class="input-group mb-5 position-relative">
                                                        <input type="text" name="text" placeholder="Enter a drug, OTC or herbal supplement." />
                                                        <p class="Interaction red">1 Interaction found</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <figure><img src="../../../../static/website/images/pills.png" alt="" /></figure>
                                            <p>
                                                Use the search field above to look up prescription or OTC <br />
                                                drugs, and herbal supplements.
                                            </p>
                                            <p>Add a full drug regimen and view interactions</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "drug-interaction-check",
        data() {
            return {};
        },
        created(){
           this.pageName('Drug Interaction Checker')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/checkup/drug-interaction-check.vue